import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AOS from 'aos';


import AnimatedHeading from './components/AnimatedHeading';
import HighlightText from './components/HighlightText';
import ArrowAnimation from './components/ArrowAnimation';

import CarouselComponent from './components/Carousel';
import Standorte from './components/StandorteIndex';

import './css/IndexSeiteStyle.css';
import './css/font-sizes.css';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const IndexSeite = () => {

    useEffect(() => {
        AOS.init({
            duration: 1200, // Optionale Konfiguration
            delay: 200
        });
    }, []);

    
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    return (
        <div id="index-wrapper">
            <Helmet>
                <title>Startseite | Limbach für Alle</title>
            </Helmet>
            <div className="banner container-fluid pb-5" >
            <ArrowAnimation />
            </div>

            <div className="container py-5 my-5" id="index-welcome">
                <div className="row text-center">
                    <div className="col-sm-12">
                        <h1 data-aos-offset="0" data-aos="fade-down"> LIMBACH-OBERFROHNA <span style={{ color: 'var(--primary-color)' }}>FÜR</span> ALLE!</h1>
                        <p data-aos="fade-up" className='pt-5' style={{ textAlign: 'justify' }}>
                            <br />Mit dem Projekt "Limbach für Alle" hat sich ein zivilcouragierter 
                            Zusammenschluss aus Gruppen, Organisationen und Einzelpersonen 
                            gefunden. Gemeinsam setzen wir uns für eine offene, gerechte und 
                            progressive Gesellschaft ein, die wieder miteinander ins Gespräch kommt. Wir 
                            organisieren bildungspolitische und kulturelle Veranstaltungen und Workshops, 
                            betreiben einen offenen Garten und ein Jugendzentrum, in dem Konzerte 
                            stattfinden. Durch unsere Bildungs- und Kulturarbeit möchten wir 
                            die Vielfalt und Inklusion in unserer Gemeinschaft stärken. .
                        </p>
                        <p data-aos="fade-up" style={{ textAlign: 'justify' }}>
                        <br />Wichtig ist uns dabei vor allem, dass Platz für neue Ideen ist und alle Menschen 
                        mit demokratischen Grundwerten eingeladen werden, mitzumachen. Unsere 
                        Angebote basieren auf basisdemokratischen Prinzipien der Teilhabe und 
                        Partizipation und laden deshalb dazu ein, mitzumachen und die eigenen Ideen 
                        einzubringen! Deshalb sind sie entweder kostenlos, oder finden zum 
                        selbstkostenpreis statt.
                        </p>
                        <p data-aos="fade-up" style={{ textAlign: 'justify' }}>
                        <br />Wir setzen uns mit unseren Projekten gegen menschenverachtende, intolerante 
                            und diskriminierende Ideologien ein. Unsere Arbeit basiert auf den Prinzipien 
                            der Solidarität, Gerechtigkeit und Gleichheit. Wir kämpfen 
                            aktiv gegen Rassismus, Sexismus, Homophobie und alle Formen 
                            von Diskriminierung.
                        </p>
                        <p data-aos="fade-up" style={{ textAlign: 'justify' }}> 
                        <br />Außerdem unterstützen wir unsere Bündnispartner in ihrer Arbeit zu 
                            verschiedenen Themen wie Klimagerechtigkeit, soziale Sicherheit, 
                            Arbeitnehmerrechte und Antifaschismus. Unser Ziel ist es, als Zivilgesellschaft  
                            wieder ins Gespräch zu kommen und gemeinsam 
                            eine nachhaltige und solidarische Gesellschaft aufzubauen, in der alle 
                            Menschen gleiche Chancen und Rechte haben.
                        </p>
                        <p data-aos="fade-up" style={{ textAlign: 'justify' }}> 
                        <br />Wir glauben fest daran, dass Veränderung durch gemeinschaftliches Handeln 
                            und gegenseitige Unterstützung möglich ist. Deshalb laden wir alle ein, sich uns
                            anzuschließen, aktiv zu werden und für eine offene Gesellschaft und gegen 
                            Demokratiefeindlichkeit einzustehen!
                        </p>
                    </div>

                    <div className='col-sm-12 pt-5'>
                        <AnimatedHeading text="AKTUELLES" />
                        <hr style={{ color: 'var(--primary-color)' }} />
                    </div>

                    <div className='col-sm-12 pt-5'>
                        <CarouselComponent />
                        <h3 className='pt-5' data-aos="fade-up">Du möchtest <Link to="/aktuelles"><HighlightText text="weitere Beiträge lesen"/></Link> , uns besser kennenlernen oder sogar bei uns mitmachen?</h3>
                        <p className='pt-5' data-aos="fade-up" style={{ textAlign: 'justify' }}>
                            
                        Dann zögere nicht und schaue auf unserer Aktuelles-Seite vorbei! Hier findest 
                        du eine Fülle von Veranstaltunginformationen, spannenden Berichten und 
                        aktuellen Nachrichten zu den vielfältigen Aktivitäten und Initiativen unseres 
                        Vereins. 
                        </p>

                        <p data-aos="fade-up" style={{ textAlign: 'justify' }}>
                        <br />Aktiv sind wir außerdem auf Instagram, wo du uns unter @limbachfueralle 
                            folgen kannst. Hier teilen wir die neusten Veranstaltungen und Infos, 
                            kurzfristige Geschehnisse oder Absagen und geben dir Einblick in unsere 
                            Arbeit.
                        </p>
                        <p data-aos="fade-up" style={{ textAlign: 'justify' }}>
                        <br />Wenn du uns persönlich kennenlernen oder bei uns mitmachen möchtest, 
                        kannst du zu einem unserer offenen, regelmäßigen Treffen kommen. Jeden 
                        Mittwoch finden um 16 Uhr der Gartentreff im <HashLink to="/standorte#standort3"><HighlightText text="offenen Garten"/></HashLink> und um 18 
                        Uhr die Küche für Alle im <HashLink to="/standorte#standort1"><HighlightText text="Infoladen"/></HashLink>  statt. Du kannst uns natürlich auch 
                        eine Email oder auf Instagram schreiben. Wir sind gespannt auf deine Ideen!
                        </p>

                        <p data-aos="fade-up" style={{ textAlign: 'justify' }}>
                            <br />Wenn du uns unterstützen möchtest, findest du unter dem Reiter “über unsˮ 
                            eine Möglichkeit zur Spende. 
                            Dein Interesse ist uns wichtig, denn nur gemeinsam können wir eine 
                            partizipative und offene Gesellschaft schaffen!
                        </p>
                    </div>

                    <div className='col-sm-12 pt-5'>
                        <AnimatedHeading text="UNSERE STANDORTE" />
                        <hr style={{ color: 'var(--primary-color)' }} />
                    </div>

                    <div className='col-sm-12 pt-5'>
                        <Standorte />
                    </div>

                    <div className='col-sm-12 pt-5'>
                        <AnimatedHeading text="UNSERE UNTERSTÜTZER" />
                        <hr style={{ color: 'var(--primary-color)' }} />
                        <img className='mt-5' id='banner-foerdermittel' src="/03_Abbildungsdatei_Orte_der_Demokratie_1-scaled.jpg" alt="Orte der Demokratie" />
                    </div>
                </div>
            </div>
        </div>



    )
};

export default IndexSeite;